export const SUBSCRIBER_LOOKUP_CODE = 'sub' as const;
export const SUBSCRIBER_LOGIN_RESPONSE_CODE = 'no_admin' as const;
